import { useState } from "react";
import { WhatsappLogo } from "@phosphor-icons/react";
import { whatsappUrl, buildQuoteMessage } from "@/lib/contact";
import { SERVICES } from "@/data/site";

export default function QuoteForm({ compact = false }) {
  const [form, setForm] = useState({
    name: "",
    city: "",
    service: SERVICES[0].title,
    vehicle: "",
    details: "",
  });

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    const msg = buildQuoteMessage(form);
    window.open(whatsappUrl(msg), "_blank", "noopener,noreferrer");
  };

  const inputCls =
    "w-full rounded-sm border border-white/15 bg-brand-obsidian px-4 py-3 text-sm text-white placeholder-white/35 transition-colors duration-200 focus:border-brand-red focus:outline-none";

  return (
    <form onSubmit={submit} data-testid="quote-form" className="space-y-4">
      <div className={`grid gap-4 ${compact ? "" : "sm:grid-cols-2"}`}>
        <div>
          <label className="mb-2 block font-mono text-xs uppercase tracking-widest text-white/50">Nome</label>
          <input
            data-testid="quote-name"
            type="text"
            required
            value={form.name}
            onChange={update("name")}
            placeholder="Seu nome"
            className={inputCls}
          />
        </div>
        <div>
          <label className="mb-2 block font-mono text-xs uppercase tracking-widest text-white/50">Cidade / Localização</label>
          <input
            data-testid="quote-city"
            type="text"
            required
            value={form.city}
            onChange={update("city")}
            placeholder="Ex.: Pimenta Bueno, BR-364 km 20"
            className={inputCls}
          />
        </div>
      </div>

      <div className={`grid gap-4 ${compact ? "" : "sm:grid-cols-2"}`}>
        <div>
          <label className="mb-2 block font-mono text-xs uppercase tracking-widest text-white/50">Serviço</label>
          <select
            data-testid="quote-service"
            value={form.service}
            onChange={update("service")}
            className={inputCls}
          >
            {SERVICES.map((s) => (
              <option key={s.slug} value={s.title} className="bg-brand-obsidian">{s.title}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="mb-2 block font-mono text-xs uppercase tracking-widest text-white/50">Veículo</label>
          <input
            data-testid="quote-vehicle"
            type="text"
            value={form.vehicle}
            onChange={update("vehicle")}
            placeholder="Ex.: Carro, caminhão, carreta..."
            className={inputCls}
          />
        </div>
      </div>

      <div>
        <label className="mb-2 block font-mono text-xs uppercase tracking-widest text-white/50">Detalhes</label>
        <textarea
          data-testid="quote-details"
          rows={compact ? 2 : 3}
          value={form.details}
          onChange={update("details")}
          placeholder="Descreva a situação do veículo"
          className={inputCls}
        />
      </div>

      <button
        type="submit"
        data-testid="quote-submit"
        className="group inline-flex w-full items-center justify-center gap-3 rounded-sm bg-brand-whatsapp px-8 py-4 font-heading font-semibold uppercase tracking-wide text-white transition-transform duration-300 hover:scale-[1.02] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-whatsapp focus-visible:ring-offset-2 focus-visible:ring-offset-brand-obsidian"
      >
        <WhatsappLogo weight="fill" className="h-5 w-5 transition-transform duration-300 group-hover:rotate-6" />
        Enviar pelo WhatsApp
      </button>
      <p className="text-center text-xs text-white/40">
        Ao enviar, você será direcionado ao WhatsApp com a mensagem pronta.
      </p>
    </form>
  );
}
